<template>
  <div class="flex-container">
    <div class="item" :style="field1Width">
      <div class="inline span" :style="field1SpanWidth">
        <span v-if="lobel1Show" class="label"> {{ field1Name }} </span>
      </div>
      <div class="inline">
        <slot v-if="field1Show" name="a"></slot>
      </div>
    </div>
    <div class="item" :style="field2Width">
      <div class="inline span" :style="field2SpanWidth">
        <span v-if="lobel2Show" class="label"> {{ field2Name }} </span>
      </div>
      <div class="inline">
        <slot v-if="field2Show" name="b"></slot>
      </div>
    </div>
    <div class="item" :style="field3Width">
      <div class="inline span" :style="field3SpanWidth">
        <span v-if="lobel3Show" class="label"> {{ field3Name }} </span>
      </div>
      <div class="inline">
        <slot v-if="field3Show" name="c"></slot>
      </div>
    </div>
    <div class="item" :style="field4Width">
      <div class="inline span" :style="field4SpanWidth">
        <span v-if="lobel4Show" class="label"> {{ field4Name }} </span>
      </div>
      <div class="inline">
        <slot v-if="field4Show" name="d"></slot>
      </div>
    </div>
    <div class="item" :style="field5Width">
      <div class="inline span" :style="field5SpanWidth">
        <span v-if="lobel5Show" class="label"> {{ field5Name }} </span>
      </div>
      <div class="inline">
        <slot v-if="field5Show" name="e"></slot>
      </div>
    </div>
    <div class="item" :style="field6Width">
      <div class="inline span" :style="field6SpanWidth">
        <span v-if="lobel6Show" class="label"> {{ field6Name }} </span>
      </div>
      <div class="inline">
        <slot v-if="field6Show" name="f"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"

export default {
  name: "FormRowTwo",
  props: {
    fieldNameArr: {
      type: Array,
      default: () => [],
    },
    fieldWidthArr: {
      type: Array,
      default: () => [],
    },
    fieldSpanWidthArr: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    field1Show() {
      return this.$slots.a
    },
    field2Show() {
      return this.$slots.b
    },
    field3Show() {
      return this.$slots.c
    },
    field4Show() {
      return this.$slots.d
    },
    field5Show() {
      return this.$slots.e
    },
    field6Show() {
      return this.$slots.f
    },
    field1Width() {
      return this.fieldWidthArr.length > 0 ? "width: " + this.fieldWidthArr[0] + "px" : ""
    },
    field2Width() {
      return this.fieldWidthArr.length > 1 ? "width: " + this.fieldWidthArr[1] + "px" : ""
    },
    field3Width() {
      return this.fieldWidthArr.length > 2 ? "width: " + this.fieldWidthArr[2] + "px" : ""
    },
    field4Width() {
      return this.fieldWidthArr.length > 3 ? "width: " + this.fieldWidthArr[3] + "px" : ""
    },
    field5Width() {
      return this.fieldWidthArr.length > 4 ? "width: " + this.fieldWidthArr[4] + "px" : ""
    },
    field6Width() {
      return this.fieldWidthArr.length > 5 ? "width: " + this.fieldWidthArr[5] + "px" : ""
    },

    lobel1Show() {
      return this.fieldNameArr.length > 0
    },
    lobel2Show() {
      return this.fieldNameArr.length > 1
    },
    lobel3Show() {
      return this.fieldNameArr.length > 2
    },
    lobel4Show() {
      return this.fieldNameArr.length > 3
    },
    lobel5Show() {
      return this.fieldNameArr.length > 4
    },
    lobel6Show() {
      return this.fieldNameArr.length > 5
    },
    field1Name() {
      return this.fieldNameArr.length > 0 ? this.fieldNameArr[0] : ""
    },
    field2Name() {
      return this.fieldNameArr.length > 1 ? this.fieldNameArr[1] : ""
    },
    field3Name() {
      return this.fieldNameArr.length > 2 ? this.fieldNameArr[2] : ""
    },
    field4Name() {
      return this.fieldNameArr.length > 3 ? this.fieldNameArr[3] : ""
    },
    field5Name() {
      return this.fieldNameArr.length > 4 ? this.fieldNameArr[4] : ""
    },
    field6Name() {
      return this.fieldNameArr.length > 5 ? this.fieldNameArr[5] : ""
    },
    field1SpanWidth() {
      return this.fieldSpanWidthArr.length > 0 ? "width: " + this.fieldSpanWidthArr[0] + "px" : ""
    },
    field2SpanWidth() {
      return this.fieldSpanWidthArr.length > 1 ? "width: " + this.fieldSpanWidthArr[1] + "px" : ""
    },
    field3SpanWidth() {
      return this.fieldSpanWidthArr.length > 2 ? "width: " + this.fieldSpanWidthArr[2] + "px" : ""
    },
    field4SpanWidth() {
      return this.fieldSpanWidthArr.length > 3 ? "width: " + this.fieldSpanWidthArr[3] + "px" : ""
    },
    field5SpanWidth() {
      return this.fieldSpanWidthArr.length > 4 ? "width: " + this.fieldSpanWidthArr[4] + "px" : ""
    },
    field6SpanWidth() {
      return this.fieldSpanWidthArr.length > 5 ? "width: " + this.fieldSpanWidthArr[5] + "px" : ""
    },
    isSmallDevice() {
      return this.getSmallDevice()
    },
  },
  methods: {
    ...mapGetters(["getSmallDevice"]),
    ...mapActions([]),
  },
}
</script>

<style scoped>
/* .item { */
/* background-color:skyblue;
  color:royalblue; */
/* margin:2px; */
/* } */
.span {
  text-align: center;
}
</style>

